export const AVATAR_URL = 'url';
export const AVATAR_GROUP = 'group';
export const AVATAR_UNKNOWN = 'unknown';
export const AVATAR_GLOBAL = 'global';
export const AVATAR_LOGGEDIN = 'loggedin';

export type Avatar =
	| { type: 'url'; url: string; circle: boolean }
	| { type: 'group' | 'unknown' | 'global' | 'loggedin' };
